import {Project, EngageApp, ReachProject} from 'airship/page/app_list/types'
import {isEngageApp} from 'airship/page/app_list/lib/run-filter'

const KEY = 'recent-project-list'

// This module works by adding entire serialized projets to the local storage.
// This has the advantage of not requring any requests to display recent
// projects, but the downside of cache invalidation. Which is addressed in the
// updateStorage function below.
export function add(project: Project) {
  const excludeKey = isEngageApp(project) ? project.key : project.contextId

  let projects = list(excludeKey)

  projects.unshift(project)
  projects = projects.slice(0, 6)

  set(projects)
}

// This function is used from the projecting listing page and is fed the entire
// project list anytime that page is loaded. This heals the cached recent
// projects and removes any from the cache that no longer exist.
export function updateStorage(apps: EngageApp[], projects: ReachProject[]) {
  const recentProjects: Project[] = list()
    .map(project => {
      if (isEngageApp(project)) {
        return apps.find(app => app.key === project.key)
      }

      return projects.find(prj => prj.contextId === project.contextId)
    })
    .filter(Boolean) as Project[]

  set(recentProjects)
}

export function list(excludeKey?: string) {
  let projects: Project[] = []
  try {
    const stored = window.localStorage.getItem(KEY)
    if (stored) {
      projects = JSON.parse(stored)
    }
  } catch (err) {
    // do nothing, `projects` is already an empty list at this point.
  }

  return projects.filter(project => {
    if (isEngageApp(project)) {
      return project.key !== excludeKey
    }
    return project.contextId !== excludeKey
  })
}

function set(projects: Project[]) {
  window.localStorage.setItem(KEY, JSON.stringify(projects))
}
